<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="content"></div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      tabIndex: 5,
    }
  },
  mounted() {
    // if (this.isMobileDevice()) {
    //   console.log("综合判断：移动端设备")
    //   this.$router.push("/mobile/home")
    // } else {
    //   console.log("综合判断：PC端设备")
    //   this.$router.push("/website/home")
    // }
  },
  methods: {
    isMobileDevice() {
      // User-Agent检测
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      const isMobileUA =
        /android|avantgo|blackberry|iemobile|ipad|iphone|ipod|j2me|midp|mobile|opera mini|phone|palm|pocket|psp|symbian|up\.browser|up\.link|wap|windows ce|xda|xiino/i.test(
          userAgent
        )

      // 屏幕尺寸检测
      const isSmallScreen = window.innerWidth <= 768

      // 触摸事件检测
      const isTouchScreen =
        "ontouchstart" in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0

      // 综合判断：如果User-Agent是移动端，或者屏幕小且支持触摸，则认为是移动端
      return isMobileUA || (isSmallScreen && isTouchScreen)
    },
  },
}
</script>
<style lang="scss" scoped>
.content {
}
</style>
